import styles from './styles.module.scss';

import React from 'react';
import NumberFormat from 'react-number-format';
import {queryParse} from 'utils/http';
import {Container} from 'reactstrap';
import {LabelCountry} from 'components/Labels';

function Component({isLoading, target, totalRows, search}) {
  const keyword = queryParse(search).search;
  const countries_id = queryParse(search).countries_id;

  return (
    <div className={styles['search-header']}>
      <Container>
        {isLoading ? (
          <div>Searching your requests...</div>
        ) : (
          <React.Fragment>
            We found &nbsp;
            <strong>
              <NumberFormat
                displayType={'text'}
                value={totalRows}
                renderText={(value) => value}
                thousandSeparator
              />
            </strong>
            &nbsp;
            {target}
            {keyword && (
              <React.Fragment>
                &nbsp;containing <strong>"{keyword}"</strong>
              </React.Fragment>
            )}
            {countries_id && (
              <React.Fragment>
                &nbsp;in&nbsp;
                <strong>
                  <LabelCountry tag={false} country_id={countries_id} />
                </strong>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </Container>
    </div>
  );
}

export default Component;
